export const validateEmail = (email) => {
  const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return re.test(email);
};

export const normalizeDigits = (value) => {
  return String(value ?? '').replace(/\D/g, '');
};

export const validateCPF = (cpf) => {
  cpf = normalizeDigits(cpf);
  if (!cpf) return false;
  if (cpf.length !== 11) return false;
  if (/^(\d)\1{10}$/.test(cpf)) return false;

  let add = 0;
  for (let i = 0; i < 9; i++)
    add += Number(cpf.charAt(i)) * (10 - i);
  let rev = 11 - (add % 11);
  if (rev === 10 || rev === 11)
    rev = 0;
  if (rev !== Number(cpf.charAt(9)))
    return false;

  add = 0;
  for (let i = 0; i < 10; i++)
    add += Number(cpf.charAt(i)) * (11 - i);
  rev = 11 - (add % 11);
  if (rev === 10 || rev === 11)
    rev = 0;
  if (rev !== Number(cpf.charAt(10)))
    return false;
  return true;
};

export const validateCNPJ = (cnpj) => {
  cnpj = normalizeDigits(cnpj);
  if (!cnpj) return false;
  if (cnpj.length !== 14) return false;
  if (/^(\d)\1{13}$/.test(cnpj)) return false;

  let tamanho = cnpj.length - 2
  let numeros = cnpj.substring(0, tamanho);
  let digitos = cnpj.substring(tamanho);
  let soma = 0;
  let pos = tamanho - 7;
  for (let i = tamanho; i >= 1; i--) {
    soma += numeros.charAt(tamanho - i) * pos--;
    if (pos < 2)
      pos = 9;
  }
  let resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
  if (resultado !== parseInt(digitos.charAt(0)))
    return false;

  tamanho = tamanho + 1;
  numeros = cnpj.substring(0, tamanho);
  soma = 0;
  pos = tamanho - 7;
  for (let i = tamanho; i >= 1; i--) {
    soma += numeros.charAt(tamanho - i) * pos--;
    if (pos < 2)
      pos = 9;
  }
  resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
  if (resultado !== parseInt(digitos.charAt(1)))
    return false;

  return true;
};

export const validateBrazilianDocument = (document) => {
  const digits = normalizeDigits(document);

  if (!digits) {
    return { isValid: false, type: null, digits };
  }

  if (digits.length === 11) {
    return { isValid: validateCPF(digits), type: 'cpf', digits };
  }

  if (digits.length === 14) {
    return { isValid: validateCNPJ(digits), type: 'cnpj', digits };
  }

  return { isValid: false, type: null, digits };
};
